module.exports = __webpack_public_path__ + "img/1523523813.eae56e25.jpg";